import React from 'react'
import { BooleanInput, FormDataConsumer } from 'react-admin'
import { accessPropertyByPath } from 'resources/operations/events/utils'
import { FormDataConsumerProps } from 'types/common'

type Props = {
  source: string
  children: JSX.Element | JSX.Element[]
  label: string
}

const ContentToggler: React.FC<Props> = ({
  children,
  source,
  label,
  ...props
}) => (
  <>
    <BooleanInput {...props} source={source} label={label} />
    <FormDataConsumer>
      {({ formData }: FormDataConsumerProps<any>) =>
        accessPropertyByPath(formData, source) && children
      }
    </FormDataConsumer>
  </>
)

export default ContentToggler
